// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__21Q8b","list":"BalanceDue_list__1F-4s","listRow":"BalanceDue_listRow__CcT38","total":"BalanceDue_total__3iTmS"};